import { render, staticRenderFns } from "./WorkIconLink.vue?vue&type=template&id=bb5f7374"
import script from "./WorkIconLink.vue?vue&type=script&lang=js"
export * from "./WorkIconLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports